import React from 'react';
import { Box, Typography } from '@mui/material';
import { AVAILABLE_COUNTRY, COLOR_PRIMARY } from 'src/const';

const DiscoverCountryPointer = ({
  lat,
  lng,
  countryCode,
  handleClick,
}: {
  lat: number;
  lng: number;
  countryCode: 'US' | 'GB' | '';
  handleClick: () => void;
}) => {
  return (
    <Box
      sx={{
        padding: '5px 10px',
        background: '#fff',
        color: COLOR_PRIMARY,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '200px',
        borderRadius: 900,
        cursor: 'pointer',
        transform: 'translate(-50%, -50%)',
        boxShadow: '0 2px 2px #0004',
      }}
      onClick={handleClick}
    >
      <Typography variant="body1" sx={{ fontWeight: 600 }}>
        Discover {AVAILABLE_COUNTRY[countryCode]}
      </Typography>
    </Box>
  );
};

export default DiscoverCountryPointer;